var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',[_c('Button',[_vm._v("+新增字典")])],1)]),_c('div',[_c('Table',[_c('div',[_c('Button',[_vm._v("确定")]),_c('Button',[_vm._v("取消")])],1),_c('div',[_c('Button',[_vm._v("编辑")]),_c('Button',[_vm._v("删除")])],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }